import { CommonModule, NgIf } from '@angular/common';
import { Component, ElementRef, OnInit,  TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { VideoModalComponent } from '../../../common/video-modal/video-modal.component';
import { CommonService } from '../../../widgets/services/common.service';
import { SearchItemComponent } from '../../components/search-item/search-item.component';
import { ISavedSearch, ISearchFacetItemQueryExpr, ISearchResult, SearchService } from '../../services/search.service';
import { NumberFormatPipe } from '../../../../modules/fwcore';
import { BusyComponent } from '../../../widgets/busy/busy.component';
import { SearchCompanyComponent } from '../../components/search-company/search-company.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchFacetsComponent } from '../../components/search-facets/search-facets.component';
import { SearchSavedComponent } from '../../components/search-saved/search-saved.component';


@Component({
  selector: 'app-search',
  standalone: true,
  imports: [SearchSavedComponent,VideoModalComponent, SearchFacetsComponent, BusyComponent, SearchItemComponent, SearchCompanyComponent, NgIf, NumberFormatPipe, NgbPaginationModule,CommonModule],
  templateUrl: './page-search.component.html',
  styleUrls: ['./page-search.component.scss']
})
export class PageSearchComponent implements OnInit {
  isFirstTime: boolean = false;
  title!: string;
  commonItems!: CommonItems[];
  videoDetail!: any;
  searchResult!: ISearchResult;
  showBusy: boolean = false;
  pageCollectionCount: number = 10;
  itemFrom: number = 1;
  itemTo: number = 10;
  showPopUp: boolean = false;
  showPopup: boolean = false;

  showThumbnails: boolean = true;
  videoType: string = "";
  selectedDocument: string = '';

  constructor(private _elementRef: ElementRef, private srchSvc: SearchService, private route: Router, private commonService: CommonService) {
    this.title = "Search";
    //this.commonService.getVideoLnks().then(data => {
    //  this.commonItems = data;
    //  if (this.commonItems.length > 0) {
    //    //this.videoDetail = this.commonItems.filter(x => x.pageTitle == this.title)[0].videoUrl;
    //  }
    //});

  }

  ngOnInit(): void {
    this.videoType = "Search";
    const dashSearchType = window.history.state['searchType'];
    const dashSearchText = window.history.state['searchText'];
    const preSelectedDocument = window.history.state['selectedDocument'];
    if (preSelectedDocument != undefined)
      this.selectedDocument = preSelectedDocument;

    if (dashSearchType != undefined && dashSearchText != undefined) {
      if (dashSearchType == 'text') {
        this.simpleSearch(dashSearchText);
      }
      else if (dashSearchType == 'saved') {
        // Run saved query
        let jsonObj: any = JSON.parse(dashSearchText);
        let query: ISavedSearch = <ISavedSearch>jsonObj;

        this.runSavedQuery(query);
      }
    }
    else {
      this.isFirstTime = true;
      this.simpleSearch('ALL');
    }
  }
  openPopup() {
    this.showPopup = true;
  }

  public async runSearch(page: number = 1, facets: ISearchFacetItemQueryExpr[] = []) {
    try {
      this.showBusy = true;

      let txtbox = this._elementRef.nativeElement.querySelector('#txtSearch');
      var searchTerm = txtbox.value;
      if (txtbox.value == '' || txtbox.value == undefined)
        searchTerm = 'ALL';
      if (this.isFirstTime) {
        this._elementRef.nativeElement.querySelector('#txtSearch').value = '';
        this.isFirstTime = false;
      }
      this.searchResult = await this.srchSvc.runNewSearch(searchTerm, facets);
      this.pageCollectionCount = Math.min(1000, this.searchResult?.estimatedCount);
      this.itemFrom = 1;
      this.itemTo = Math.min(this.searchResult.pageSize, this.searchResult?.estimatedCount);
      if (this.selectedDocument != '') {
        //alert(this.selectedDocument);
      }
      else {
        // alert('NOT FROM SELECTED DOCUMENT');
      }
    }
    catch (e) {
      console.log(e);
    }
    finally {
      this.showBusy = false;
    }
  }

  public async loadPage(page: number) {
    try {
      this.showBusy = true;

      this.searchResult = await this.srchSvc.getSearchPage(page);
      this.pageCollectionCount = Math.min(1000, this.searchResult?.estimatedCount);
      this.itemFrom = this.getPageFrom(this.searchResult.pageNumber);
      this.itemTo = Math.min(this.itemFrom + this.searchResult.pageSize - 1, this.searchResult?.estimatedCount);
    }
    catch (e) {
      console.log(e);
    }
    finally {
      this.showBusy = false;
    }
  }

  private getPageFrom(pageNumber: number): number {
    return ((pageNumber - 1) * 10) + 1;
  }

  public simpleSearch(term: string) {
    let txtbox = this._elementRef.nativeElement.querySelector('#txtSearch');
    txtbox.value = term;

    this.runSearch();
  }

  public async runSavedQuery(query: ISavedSearch) {
    try {
      this.showBusy = true;
      this.searchResult = await this.srchSvc.runNewSearchFromRequest(query.searchRequest);
      this.pageCollectionCount = Math.min(1000, this.searchResult?.estimatedCount);
      this.itemFrom = this.getPageFrom(this.searchResult.pageNumber);
      this.itemTo = Math.min(this.itemFrom + this.searchResult.pageSize - 1, this.searchResult?.estimatedCount);

      let txtbox = this._elementRef.nativeElement.querySelector('#txtSearch');
      txtbox.value = query.searchRequest.term;

    }
    catch (e) {
      console.log(e);
    }
    finally {
      this.showBusy = false;
    }
  }

  public filterClick(event: ISearchFacetItemQueryExpr[]) {
    this.runSearch(1, event);
  }
  closeVideoPopup(ev: any) {
    this.showPopup = false;
  }
  async clearSearch() {
    (document.getElementsByClassName('search-spinner')[0] as HTMLElement).style.display = 'block';
    this._elementRef.nativeElement.querySelector('#txtSearch').value = '';
    this.searchResult = {} as ISearchResult;
    this.pageCollectionCount = 0;
    await this.runSearch();
    (document.getElementsByClassName('search-spinner')[0] as HTMLElement).style.display = 'none';
  }
}
export interface CommonItems {
  id: string
  pageTitle: string;
  videoUrl: string;
  isActive: boolean;
  selectQuery: any;
  selectType: any;
  loginRequired: any;
}
